import React, { ComponentType, PureComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";

import { resendEmailConfirmation } from "@/data/session";

import { IEmailMessageProps } from "./EmailMessage";

export interface IWithEmailResendProps extends IEmailMessageProps, WithTranslation {
  email: string;
}

export function withEmailResend<P extends IWithEmailResendProps>(Component: ComponentType<P>) {
  interface Props extends WithTranslation, Pick<P, "email"> {}

  interface State {
    emailSent: boolean;
    message?: string;
    working: boolean;
  }

  class WithEmailResend extends PureComponent<Props> {
    readonly state: State = {
      emailSent: false,
      working: false,
    };

    handleResend = async () => {
      const { t } = this.props;
      this.setState({ working: true });
      try {
        await resendEmailConfirmation({}, { email: this.props.email });
        this.setState({ message: t("SESSION_EMAIL.SUCCESS_MESSAGE") });
      } catch (error) {
        this.setState({ message: t("common:ERROR_MESSAGES.GENERAL") });
      } finally {
        this.setState({ emailSent: true, working: false });
      }
    };

    render() {
      const { emailSent, message, working } = this.state;

      return (
        <Component
          handleResend={this.handleResend}
          resendDisabled={emailSent || working}
          message={message}
          {...(this.props as P)}
        />
      );
    }
  }

  return withTranslation(["public", "common"])(WithEmailResend);
}
